import { PregameStatusFilters } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const eventStartPeriodDictionary = createSimpleDictionary([
    { id: PregameStatusFilters.Today, name: 'dictionaries.gameStatus.todayGames' },
    { id: PregameStatusFilters.NotStarted, name: 'dictionaries.gameStatus.notStarted' },
    { id: PregameStatusFilters.Next1h, name: 'dictionaries.gameStatus.next1h' },
    { id: PregameStatusFilters.Next2h, name: 'dictionaries.gameStatus.next2h' },
    { id: PregameStatusFilters.Next4h, name: 'dictionaries.gameStatus.next4h' },
]);
